import React, { useEffect, useRef } from "react";
import { Icon } from "antd-mobile";
import { fetchPaging } from "@Services/api";
import { useInfiniteQuery } from "react-query";
import styles from "./index.module.less";
import cx from "classnames";
interface IProps {
  request: any;
  emptyContent?: React.ReactNode;
  children: React.ReactNode;
  cache: string;
  params?: any;
  callback?: (data: any) => void;
  style?: React.CSSProperties;
  listDataKey?: string;
}

const Empty = () => {
  return (
    <div className={styles["scroll-empty-content"]}>
      <i className={styles["empty-icon"]} />
      <div className={styles["empty-content"]}>暫無資料</div>
    </div>
  );
};

const ScrollLoad: React.FC<IProps> = ({
  emptyContent,
  children,
  request,
  cache,
  callback,
  params = {},
  style,
  listDataKey = "list",
}) => {
  const ref = useRef(null);
  const fetchProjects = async (page) => {
    const res = !page?.pageParam ? await request(params) : await fetchPaging(page?.pageParam);
    if (res?.status === 12000) {
      callback && callback(res.data);
      return res.data;
    }
  };
  const {
    data = { pages: [] },
    fetchNextPage,
    hasNextPage,
    isFetching,
    isFetchingNextPage,
    status,
  } = useInfiniteQuery(cache, fetchProjects, {
    getNextPageParam: (lastPage, pages) => {
      return lastPage.paging === "" ? false : lastPage.paging;
    },
  });

  useEffect(() => {
    if (!data.pages) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.intersectionRatio === 0) return;
          hasNextPage && fetchNextPage();
        });
      },
      {
        threshold: 0.000001, // 交叉占比（0～1），达到该比例才触发回调
      },
    );
    observer.observe(ref.current);

    return () => {
      observer.disconnect();
    };
  }, [data]);

  return (
    <>
      <div className={styles["ScrollLoad"]} style={style}>
        {React.isValidElement(children) &&
          Array.isArray(data?.pages) &&
          data.pages.map((list, ii) =>
            Array.isArray(list?.[listDataKey]) && list?.[listDataKey].length !== 0 ? (
              list[listDataKey].map((item: any, index: number) => (
                <div key={index}>{React.cloneElement(children as React.ReactElement<any>, item)}</div>
              ))
            ) : !!emptyContent ? (
              <div key={ii}>{emptyContent}</div>
            ) : (
              <Empty key={ii} />
            ),
          )}

        <div className={styles["scroll-defend"]} ref={ref} style={{ top: style ? "0" : "-200" }} />
      </div>
      {!!data.pages && isFetching && (
      <div className={styles["scroll-loading"]}>
        <div className={styles["loading-content"]}>
          <Icon className={styles["loading-icon"]} type={"loading"} />
          Loading...
        </div>
      </div>
      )}
      {data.pages[0]?.[listDataKey].length !== 0 && hasNextPage === false && (
        <div className={styles["on-eath"]}>已經到底了</div>
      )}
    </>
  );
};

export default React.memo(ScrollLoad);
